<template>
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.9584 15.375L9.00008 11.8333L4.04175 15.375V4.04167C4.04175 3.66594
      4.191 3.30561 4.45668 3.03993C4.72236 2.77426 5.08269 2.625 5.45841
      2.625H12.5417C12.9175 2.625 13.2778 2.77426 13.5435 3.03993C13.8092
      3.30561 13.9584 3.66594 13.9584 4.04167V15.375Z"
      stroke="#F7F8FD"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
